import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { ActivityRepRow } from '@/models/salesAnalytics'

const COLUMNS: { key: keyof ActivityRepRow; label: string }[] = [
  { key: 'callsOut', label: 'Calls out' },
  { key: 'callsIn', label: 'Calls in' },
  { key: 'callsMissed', label: 'Missed' },
  { key: 'emailsOut', label: 'Emails out' },
  { key: 'emailsIn', label: 'Emails in' },
  { key: 'smsOut', label: 'SMS out' },
  { key: 'smsIn', label: 'SMS in' },
  { key: 'notes', label: 'Notes' },
]

export function ActivityCard({ rows }: { rows: ActivityRepRow[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Activity by rep</CardTitle>
        <p className="text-sm text-neutral-500">
          Reps are the people who own leads or customers, so bots and staff who never sell stay out. System
          counts the status changes and field updates written for a rep rather than by one.
        </p>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Rep</TableHead>
                {COLUMNS.map((column) => (
                  <TableHead key={column.key} className="text-right">
                    {column.label}
                  </TableHead>
                ))}
                <TableHead className="text-right">Outreach</TableHead>
                <TableHead className="text-right">Other</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.repId}>
                  <TableCell>{row.repName}</TableCell>
                  {COLUMNS.map((column) => (
                    <TableCell key={column.key} className="text-right tabular-nums">
                      {row[column.key] as number}
                    </TableCell>
                  ))}
                  <TableCell className="text-right tabular-nums">{row.outreach}</TableCell>
                  <TableCell className="text-right text-neutral-500 tabular-nums">{row.system}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  )
}
